export default "__VITE_ASSET__5bc7e50d__"